// reducers/purchaseInvoices.js

import {
  START_LOADING,
  END_LOADING,
  FETCH_PURCHASE_INVOICES,
  FETCH_PURCHASE_INVOICE,
  ADD_PURCHASE_INVOICE,
  UPDATE_PURCHASE_INVOICE,
  DELETE_PURCHASE_INVOICE,
  CLEAR_CURRENT_PURCHASE_INVOICE,
} from "../actions/constants";

const initialState = {
  isLoading: false,
  purchaseInvoices: [],
  purchaseInvoice: null,
  numberOfPages: 0,
};

const purchaseInvoices = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };

    case END_LOADING:
      return { ...state, isLoading: false };

    case FETCH_PURCHASE_INVOICES:
      return {
        ...state,
        purchaseInvoices: action.payload.data,
        numberOfPages: action.payload.numberOfPages,
      };

    case FETCH_PURCHASE_INVOICE:
      return { ...state, purchaseInvoice: action.payload };

    case ADD_PURCHASE_INVOICE:
      return {
        ...state,
        purchaseInvoices: [...state.purchaseInvoices, action.payload],
        purchaseInvoice: action.payload, // Assuming you want to view the newly added purchase invoice
      };

    case UPDATE_PURCHASE_INVOICE:
      return {
        ...state,
        purchaseInvoices: state.purchaseInvoices.map((invoice) =>
          invoice._id === action.payload._id ? action.payload : invoice
        ),
        purchaseInvoice:
          state.purchaseInvoice &&
          state.purchaseInvoice._id === action.payload._id
            ? action.payload
            : state.purchaseInvoice,
      };

    case DELETE_PURCHASE_INVOICE:
      return {
        ...state,
        purchaseInvoices: state.purchaseInvoices.filter(
          (invoice) => invoice._id !== action.payload
        ),
        purchaseInvoice:
          state.purchaseInvoice && state.purchaseInvoice._id === action.payload
            ? null
            : state.purchaseInvoice,
      };

    case CLEAR_CURRENT_PURCHASE_INVOICE:
      return { ...state, purchaseInvoice: null };

    default:
      return state;
  }
};

export default purchaseInvoices;
